import { render, staticRenderFns } from "./CustomerInvoiceInfoList.vue?vue&type=template&id=88ddedfa"
import script from "./CustomerInvoiceInfoList.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports